import { useQuery } from 'react-query'
import { fetchSiteById } from './fetchSiteById'
import type { SiteDetailsRequestParams } from './fetchSiteById'

export const useFetchSiteById = (params: SiteDetailsRequestParams) => {
  return useQuery(['fetchSiteById', params], fetchSiteById(params))
}
